import React from 'react';
import './App.css';
import './main.css';
import PageRoutes from './pages/PageRoutes'
import { SelectionDataContextProvider } from './hooks/context/SelectionDataContext'
import { BrowserRouter as Router } from "react-router-dom"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { OCLandInsightsContextProvider } from './hooks/context/OcLandInsightsContext';
import { PageConfigurationContextProvider } from './hooks/context/PageConfigurationContext';
import { ThemeProvider } from "@mui/material/styles";
import { theme } from './themes/MuiTheme';
import { DocLinkListContextProvider } from './hooks/context/DocLinkListContext';
import { MsalProvider } from '@azure/msal-react';
import {msalInstance} from './oauth/msal/msalConfig'

function App() {
  const queryClient = new QueryClient();
  return (
    <MsalProvider instance={msalInstance}>
    <ThemeProvider theme={theme}>
    <Router basename={process.env.PUBLIC_URL}>
      <QueryClientProvider client={queryClient}>
        <PageConfigurationContextProvider>
    <SelectionDataContextProvider>
      <OCLandInsightsContextProvider>
        <DocLinkListContextProvider>
      <div className="App">
        <PageRoutes />
      </div>
      </DocLinkListContextProvider>
      </OCLandInsightsContextProvider>
    </SelectionDataContextProvider>
    </PageConfigurationContextProvider>
    </QueryClientProvider>
    </Router>
    </ThemeProvider>
    </MsalProvider>
  );
}

export default App;
